// src/utils/useLightbox.js
import { useState, useCallback } from 'react';

export default function useLightbox() {
  const [isOpen, setIsOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const openLightbox = useCallback((src) => {
    setImageSrc(src);
    setIsOpen(true);
  }, []);

  const closeLightbox = useCallback(() => {
    setIsOpen(false);
    setImageSrc(null);
  }, []);

  const Lightbox = () =>
    isOpen ? (
      <div
        onClick={closeLightbox}
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          cursor: 'zoom-out',
        }}
      >
        <img
          src={imageSrc}
          alt=""
          style={{
            maxWidth: '90%',
            maxHeight: '90%',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          }}
        />
      </div>
    ) : null;

  return { openLightbox, Lightbox };
}
